export enum PaymentGateway {
    PayPal = 'PayPal',
    Stripe = 'Stripe',
    Checkout = 'Checkout',
    Custom = 'Custom',
    None = 'None',
}

export default interface IPaymentGateway {
    apiKey: string;
    gateway: PaymentGateway;
    paymentMethodType: string;
    // Custom gateway only; undefined for all others.
    gatewayName?: string;
    imageUrl?: string;
    paymentUrl?: string;
}
